/**
 * The heading of a step inside a sign-in card, such as MFA or SSO. It uses GatewayContent's type scale and centering.
 * It is an `h2`, because the step can sit in a card that already has an `h1` (the invite page).
 */
export function StepHeading({ title, description }: { title: string; description: string }): React.ReactElement {
  return (
    <div className="text-center">
      <h2 className="text-xl font-semibold tracking-[-0.02em] text-foreground">{title}</h2>
      <p className="mt-2 text-sm text-muted-foreground">{description}</p>
    </div>
  );
}
